import { Box, TextNew } from '@jfs/ui-new'
import { LayoutChangeEvent, StyleSheet, TouchableOpacity, View } from 'react-native'

interface TabProps {
  title: string
  state: 'selected' | 'normal'
  onSelected: () => void
  onLayout?: (event: LayoutChangeEvent) => void
}

export const CustomTab = ({ title, state, onSelected, onLayout }: TabProps) => {
  const isSelected = state === 'selected'

  return (
    <TouchableOpacity activeOpacity={0.8} onPress={onSelected} onLayout={onLayout} style={styles.tabContainer}>
      <Box paddingHorizontal={16} height={48} justifyContent="center" alignItems="center">
        <TextNew
          fontSize={14}
          fontWeight={isSelected ? 'bold' : '500'}
          color="WHITE" // Correctly uses the theme prop
        >
          {title}
        </TextNew>
      </Box>

      {/* Bottom Border Logic */}
      {isSelected && <View style={styles.activeIndicator} />}
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  tabContainer: {
    backgroundColor: '#DF9F39', // Brown Background
    minWidth: 90,
    position: 'relative',
  },
  activeIndicator: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 6,
    backgroundColor: '#FFFFFF', // White Bottom Border
  },
})
